module.exports = __webpack_public_path__ + "kudos_51.svg?9dadd1387c6a7305f8a3574baf4ab0b1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_51.svg
// module id = 152
// module chunks = 0